export default __webpack_public_path__ + "static/media/_Develope.48a8617e.svg";